import { DragAndDropState } from './DragAndDropState';
import { FiltersMap } from '@wix/bex-core';
import { createPortal } from 'react-dom';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { visuallyHidden } from '../VisuallyHidden';
import { useWixPatternsContainer } from '@wix/bex-core/react';

export interface DragAndDropAnnouncementsProps<T, F extends FiltersMap> {
  state: DragAndDropState<T, F>;
  dataHook?: string;
}

function _DragAndDropAnnouncements<T, F extends FiltersMap>(
  props: DragAndDropAnnouncementsProps<T, F>,
) {
  const { state, dataHook } = props;

  const {
    environment: { language },
    translate: t,
  } = useWixPatternsContainer();

  const {
    active,
    over,
    collection: { total },
  } = state;

  if (state.a11yContainer == null) {
    return null;
  }

  const announcement = (() => {
    switch (state.status) {
      case 'start':
        if (active) {
          return t('cairo.dragAndDrop.live-region.itemGrabbed.sr');
        }

        return;

      case 'over':
        if (over && over.id !== active?.id) {
          return t('cairo.dragAndDrop.live-region.itemDragged.sr', {
            currentNumber: over.index + 1,
            totalNumber: total,
          });
        }

        if (active) {
          return t('cairo.dragAndDrop.live-region.itemGrabbed.sr');
        }

        return;
      case 'end':
        if (over) {
          if (over.id === active?.id) {
            return t('cairo.dragAndDrop.reorder-cancelled.sr');
          }

          return t('cairo.dragAndDrop.live-region.itemDropped.sr', {
            currentNumber: over.index + 1,
          });
        }
        return;
      case 'cancel':
        return t('cairo.dragAndDrop.reorder-cancelled.sr');
    }

    return;
  })();

  let child = (
    <div
      data-hook={dataHook}
      style={visuallyHidden}
      role="status"
      aria-live="assertive"
      aria-atomic
      lang={language}
    >
      {announcement}
    </div>
  );

  child = createPortal(child, state.a11yContainer);

  return child;
}

export const DragAndDropAnnouncements = observer(_DragAndDropAnnouncements);
